import { render, staticRenderFns } from "./AvailabilityTypeToggle.vue?vue&type=template&id=71d28cd1"
import script from "./AvailabilityTypeToggle.vue?vue&type=script&lang=js"
export * from "./AvailabilityTypeToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports